import {DOWNLOAD_MANUAL_IMAGES, DOWNLOAD_MEASUREMENTLIST, FETCH_LOG, FETCH_VIRTUAL_LOG} from "@/store/actions.type";
import {SET_BUNDLES, SET_DETAIL_ITEM, SET_LOADING} from "@/store/mutations.type";
import {ExportService, SearchService, VirtualLogService} from "@/common/api";

const state = {
	log: null
};

const getters = {
	log: state => state.log
};

const actions = {
	async [FETCH_LOG]({commit}, identifier) {
		commit(SET_LOADING, true);
		return SearchService.find(identifier)
			.then(({data}) => {
				commit(SET_LOADING, false);
				return data;
			})
			.catch(error => {
				throw new Error(error);
			})
	},
	async [FETCH_VIRTUAL_LOG]({commit}, identifier) {
		commit(SET_LOADING, true);
		return VirtualLogService.find(identifier)
			.then(({data}) => {
				commit(SET_LOADING, false);
				return data;
			})
			.catch(error => {
				throw new Error(error);
			})
	},
	[DOWNLOAD_MEASUREMENTLIST]({commit}, params) {
		ExportService.downloadMeasurementList(params);
	},
	[DOWNLOAD_MANUAL_IMAGES]({commit}, params) {
		ExportService.downloadManualImages(params);
	}
};

const mutations = {
	[SET_DETAIL_ITEM](state, item) {
		state.log = item;
	},
	[SET_BUNDLES](state, bundles) {
		if (state.log) {
			state.log.bundles = bundles;
		}
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};